<template>
  <div class="md-layout md-gutter">
    <div class="md-layout-item md-size-25">
      <termo-tipo :termo="termoTipo" @change="changeTermo" />
    </div>
    <div class="md-layout-item md-size-75">
      <termo-valor
        v-if="termoTipo.tipo === tipoTermo.Literal"
        :initial-value="termo && termo.value"
        @change="changeTermoValue"
      />
      <termo-sensor
        v-if="termoTipo.tipo === tipoTermo.Sensor"
        :local-id="localId"
        :initial-sensor-id="termo && termo.sensorId"
        @change="changeTermoValue"
      />

      <termo-sensor-virtual
        v-if="termoTipo.tipo === tipoTermo.SensorVirtual"
        :local-id="localId"
        :initial-sensor-virtual-id="termo && termo.sensorVirtualId"
        @change="changeTermoValue"
      />

      <termo-avg
        v-if="
          termoTipo.tipo === tipoTermo.Funcao &&
          termoTipo.identificador === 'AVG'
        "
        :local-id="localId"
        :initial-sensor-id="termo.sensorId"
        :initial-value="+termo.quantidadeDadosAnteriores"
        @change="changeTermoValue"
      />
      <termo-compara-ultimos-dados
        v-if="
          termoTipo.tipo === tipoTermo.Funcao &&
          termoTipo.identificador === 'ComparaUltimosDados'
        "
        :local-id="localId"
        :initial-sensor-id="termo.sensorId"
        :initial-comparador="termo.comparador"
        :initial-value-base="+termo.valor"
        :initial-value="+termo.quantidadeDadosAnteriores"
        @change="changeTermoValue"
      />
      <verifica-ultimo-envio
        v-if="
          termoTipo.tipo === tipoTermo.Funcao &&
          termoTipo.identificador === 'VerificaUltimoEnvio'
        "
        :local-id="localId"
        :initial-sensor-id="termo.sensorId"
        :initial-periodo="termo.periodo"
        @change="changeTermoValue"
      />
    </div>
  </div>
</template>

<script>
import { Termos, TipoTermo, TipoTermoString } from '@/utils/constants'

import TermoAvg from './Termos/TermoAvg'
import TermoComparaUltimosDados from './Termos/TermoComparaUltimosDados'
import TermoSensor from './Termos/TermoSensor'
import TermoSensorVirtual from './Termos/TermoSensorVirtual.vue'
import TermoValor from './Termos/TermoValor'
import VerificaUltimoEnvio from './Termos/VerificaUltimoEnvio'
import TermoTipo from './TermoTipo'

export default {
  name: 'Termo',
  components: {
    TermoSensorVirtual,
    VerificaUltimoEnvio,
    TermoComparaUltimosDados,
    TermoAvg,
    TermoSensor,
    TermoValor,
    TermoTipo,
  },
  props: {
    localId: {
      type: String,
      required: true,
    },
    termo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      termoTipo: {
        tipo: 1,
      },
      termoData: {},
      tipoTermo: TipoTermo,
    }
  },
  beforeMount() {
    if (this.termo) {
      const termoTipo =
        TipoTermoString[this.termo.tipo] || this.termo.identificador
      this.termoTipo = Termos[termoTipo]
      this.termoData = this.termo
    }
  },
  methods: {
    changeTermo(data) {
      this.termoTipo = data

      this.$emit('change', {
        ...this.termoData,
        ...this.termoTipo,
      })
    },
    changeTermoValue(data) {
      this.termoData = { ...this.termoTipo, ...data }

      this.$emit('change', { ...this.termoData })
    },
  },
}
</script>

<style scoped></style>
